import {
  DataTableDataSearchDto,
  TableModalRequestDto,
} from '@asset-metrix/portal-gateway-client-js';
import { Options } from '@asset-metrix/portal-ui';
import { QueryFunction } from '@tanstack/react-query';

import { portalGatewayClient } from '../portalGatewayClient';

type FetchDocumentUploadModalValuesQueryKey = readonly [
  string,
  {
    contentId?: string;
    filter: DataTableDataSearchDto['selection'];
    context?: TableModalRequestDto['context'];
  },
];

export type ModalValues = { [p: string]: Options } | undefined;

export const fetchDocUploadModalValues: QueryFunction<
  ModalValues,
  FetchDocumentUploadModalValuesQueryKey
> = async ({ queryKey }) => {
  const [, { filter, contentId, context }] = queryKey;

  if (!contentId) {
    return;
  }

  const res = await portalGatewayClient.table.searchTableModalValues(
    contentId,
    { selection: filter, context }
  );

  if (res.data.status === 'success') {
    return res.data.data.modalValues;
  }
};
